/* Queen's Hand — theme scripts (no dependencies) */
(function () {
  'use strict';
  var QH = window.QH || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header scroll state ---------- */
  var onScroll = function () { document.body.classList.toggle('is-scrolled', window.scrollY > 10); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
  }
  QH.openDrawer = openDrawer;
  QH.closeDrawers = closeDrawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && !document.getElementById('CartDrawer')) return; // falls back to cart page link
      e.preventDefault();
      openDrawer(id);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }

    var st = e.target.closest('[data-search-toggle]');
    if (st) {
      var bar = document.getElementById('HeaderSearch');
      if (bar) { e.preventDefault(); bar.hidden = !bar.hidden; if (!bar.hidden) { var i = bar.querySelector('input'); if (i) i.focus(); } }
    }

    var mo = e.target.closest('[data-modal-open]');
    if (mo) {
      var m = document.getElementById(mo.getAttribute('data-modal-open'));
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
    }
    var mc = e.target.closest('[data-modal-close]');
    if (mc) { var dlg = mc.closest('dialog'); if (dlg) dlg.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Announcement rotator ---------- */
  function initAnnouncements(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar._qhInit) return; bar._qhInit = true;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$('.reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!b) return;
    var wrap = b.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
    var v = parseInt(input.value, 10) || 0;
    v = b.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: variants + gallery ---------- */
  function initProducts(root) {
    $$('[data-product]', root).forEach(function (el) {
      if (el._qhInit) return; el._qhInit = true;
      var json = el.querySelector('[data-variants]');
      var variants = json ? JSON.parse(json.textContent) : [];
      var idInput = el.querySelector('form [name="id"]');
      var addBtn = el.querySelector('[data-add-button]');
      var priceCur = el.querySelector('[data-price-current]');
      var priceCmp = el.querySelector('[data-price-compare]');
      var priceWrap = el.querySelector('[data-price]');
      var selLabels = $$('[data-selected-value]', el);

      function selected() {
        return $$('[data-option-index]', el).map(function (grp) {
          var checked = grp.querySelector('input:checked');
          if (checked) return checked.value;
          var sel = grp.querySelector('select');
          return sel ? sel.value : null;
        });
      }
      function update() {
        var opts = selected();
        selLabels.forEach(function (l, i) { if (opts[i] != null) l.textContent = opts[i]; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        // availability hints on pills
        $$('[data-option-index]', el).forEach(function (grp) {
          var idx = parseInt(grp.getAttribute('data-option-index'), 10);
          $$('input', grp).forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
            var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = QH.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceCur) priceCur.textContent = v.price;
        if (priceCmp) { priceCmp.textContent = v.compare || ''; priceCmp.hidden = !v.on_sale; }
        if (priceWrap) priceWrap.classList.toggle('price--sale', v.on_sale);
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? QH.strings.addToCart : QH.strings.soldOut; }
        if (v.media) showSlide(el, String(v.media));
        if (el.hasAttribute('data-update-url') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      el.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
      el.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (t) { e.preventDefault(); showSlide(el, t.getAttribute('data-thumb')); }
      });
    });
  }
  function showSlide(el, mediaId) {
    var slide = el.querySelector('[data-slide="' + mediaId + '"]');
    if (!slide) return;
    $$('[data-slide]', el).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    $$('[data-thumb]', el).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === mediaId); });
    var gal = el.querySelector('.gallery--stacked');
    if (gal && window.innerWidth > 749) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ---------- Cart (AJAX + drawer) ---------- */
  function renderDrawer(html) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var cur = drawer.querySelector('[data-cart-drawer-inner]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function refreshCount() {
    return fetch(QH.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || QH.cartType !== 'drawer' || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = QH.strings.adding; }
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(QH.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          if (err) { err.textContent = res.description || res.message; err.hidden = false; }
          return;
        }
        renderDrawer(res.sections && res.sections['cart-drawer']);
        refreshCount();
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  function changeLine(line, qty) {
    var drawer = document.getElementById('CartDrawer');
    var inner = drawer && drawer.querySelector('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    return fetch(QH.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { renderDrawer(res.sections && res.sections['cart-drawer']); return refreshCount(); })
      .finally(function () { if (inner) inner.classList.remove('is-loading'); });
  }
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('#CartDrawer [data-line]');
    if (inp) { changeLine(parseInt(inp.getAttribute('data-line'), 10), parseInt(inp.value, 10) || 0); return; }
    var note = e.target.closest('#CartDrawer [data-cart-note]');
    if (note) { fetch(QH.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); return; }
    var auto = e.target.closest('form[data-cart-autosubmit] input[name="updates[]"]');
    if (auto) { auto.form.submit(); return; }
    var sort = e.target.closest('[data-sort]');
    if (sort) { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); return; }
    var fil = e.target.closest('form[data-filter-form] input[type="checkbox"]');
    if (fil) fil.form.submit();
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('#CartDrawer [data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
  });

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el._qhInit || el.children.length) return; el._qhInit = true;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initProducts(el); }
        });
    });
  }

  /* ---------- Init + theme editor support ---------- */
  function init(root) { initAnnouncements(root); initReveal(root); initProducts(root); initRecommendations(root); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('#CartDrawer')) closeDrawers();
  });
  window.QH = QH;
})();
